module.exports = __webpack_public_path__ + "img/tienda_nube.f5fbeff0.png";